/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Richtextlinktext3Inputs */

const en_richtextlinktext3 = /** @type {(inputs: Richtextlinktext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text to display`)
};

const de_richtextlinktext3 = /** @type {(inputs: Richtextlinktext3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angezeigter Text`)
};

/**
* | output |
* | --- |
* | "Text to display" |
*
* @param {Richtextlinktext3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const richtextlinktext3 = /** @type {((inputs?: Richtextlinktext3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Richtextlinktext3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_richtextlinktext3(inputs)
	return de_richtextlinktext3(inputs)
});
export { richtextlinktext3 as "richTextLinkText" }